import AxiosInstance from "../config/AxiosInstance";
import { fetchAllPages } from "../page/Role/roleLogic";

/**
 * Danh sách promotion cho dashboard (Promo page).
 * GET /api/inventory/promotions/list-for-dashboard
 */
export const getPromotionForDashboard = async (payload: {
  page: number;
  limit: number;
  searchPromoName?: string;
  searchSchedule?: string;
  searchDescription?: string;
}) => {
  const { data } = await AxiosInstance.get(
    "/api/inventory/promotions/list-for-dashboard",
    {
      params: {
        page: payload.page,
        limit: payload.limit,
        searchPromoName: payload.searchPromoName ?? "",
        searchSchedule: payload.searchSchedule ?? "",
        searchDescription: payload.searchDescription ?? "",
      },
    },
  );
  return { data };
};

export type PromotionDashboardItem = {
  id: string;
  promoName: string;
  promoDescription?: string;
  companyId?: string;
  isGlobal?: boolean;
  isActive?: boolean;
  [key: string]: unknown;
};

// Every promotion of the company for the device-role picker, read page by page (no 500 cap).
export async function fetchPromotionsForDeviceUserRoleList(options?: {
  pageSize?: number;
}): Promise<PromotionDashboardItem[]> {
  const pageSize = options?.pageSize ?? 100;
  return fetchAllPages<PromotionDashboardItem>(async (page, limit) => {
    const res = await getPromotionForDashboard({ page, limit });
    return { rows: (res.data?.data ?? []) as PromotionDashboardItem[], count: Number(res.data?.count ?? 0) };
  }, pageSize);
}
